import React, { useState, useEffect, useCallback } from 'react';
import {
  Container, Grid, Card, CardContent, Typography, TextField, Button,List,
  ListItem,Avatar,ListItemAvatar,
  ListItemText,Divider,Badge,Checkbox,LinearProgress,
  Box, Alert, Table, TableBody, TableCell, TableContainer, TableHead,Chip,FormLabel,RadioGroup,FormControlLabel,Radio,
  TableRow, Paper, IconButton, MenuItem, Select, FormControl, InputLabel, CircularProgress, Pagination, Accordion,
  AccordionSummary, AccordionDetails, ListItemSecondaryAction, Dialog, DialogTitle, DialogContent, DialogActions,Switch,FormHelperText
} from '@mui/material';
import { Edit, Delete, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { Save as SaveIcon } from '@mui/icons-material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell
} from 'recharts';
import api from '../services/api';
import ProductPositionManager from '../components/ProductPositionManager';
import CategoryPositionManager from '../components/CategoryPositionManager';
import SectionImageUpload from '../components/SectionImageUpload';
import { useNavigate } from 'react-router-dom';
import { isDiscountActive, calculateDiscountedPrice } from '../utils/discountUtils';
import ImageUpload from '../components/ImageUpload';
import PeopleIcon from '@mui/icons-material/People';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PendingIcon from '@mui/icons-material/PendingActions';
import WarningIcon from '@mui/icons-material/Warning';
import PaymentIcon from '@mui/icons-material/Payment';
import PrintIcon from '@mui/icons-material/Print';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  CardGiftcard as CardGiftcardIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  Add as AddIcon,
  Straighten as SizeIcon,
  Extension as ExtrasIcon,
  Close as CloseIcon,
  DragHandleRounded as DragIcon,
  Category as CategoryIcon,
  VisibilityOff as VisibilityOffIcon,
  Visibility as VisibilityIcon,
  SportsEsports as SportsEsportsIcon
} from '@mui/icons-material';
import { useAdminChat } from '../context/AdminChatContext';
import OutOfStockDialog from '../components/OutOfStockDialog';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8'];
const cardStyles = {
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
  },
  color: '#ffa600f2',
  background: '#1a1919',
  height: '100%',
  display: 'flex',
  flexDirection: 'column'
};

const AdminDashboard = ({keywordsData, language}) => {
   const {
      socket,isConnected
    } = useAdminChat();
  const [outOfStockDialogOpen, setOutOfStockDialogOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [salesData, setSalesData] = useState([]);
  const [paymentPoints, setPaymentPoints] = useState([]);
  const [pointsData, setPointsData] = useState([]);
  const [timeRange, setTimeRange] = useState('monthly');
  const [year, setYear] = useState(new Date().getFullYear());
  const navigate = useNavigate();
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [printers, setPrinters] = useState([]);
  const [printersLoading, setPrintersLoading] = useState(false);
  const addProductTitleTxt = language === 'ar' ? 'إضافة المنتج' : 'Add Product'
  const editProductTitleTxt = language === 'ar' ? 'تعديل المنتج' : 'Edit Product'
  const addProductBtnTxt = language === 'ar' ? 'إضافة' : 'Add'
  const editProductBtnTxt = language === 'ar' ? 'تحديث' : 'Update'
  const addSctionBtnTxt = language === 'ar' ? 'إضافة القسم' : 'Add section'
  const editSectionBtnTxt = language === 'ar' ? 'تحديث القسم' : 'Update section'
  const unActiveDiscountTxt = language === 'ar' ? 'غير نشط' : 'Not Active'
  const activeDiscountTxt = language === 'ar' ? 'نشط' : 'Active'
  const saveBtnTxt = language === 'ar' ? 'حفظ الإعدادات' : 'Save'
  const savingBtnTxt = language === 'ar' ? 'جاري الحفظ...' : 'Saving...'
  // In your component
const [positionManagerOpen, setPositionManagerOpen] = useState(false);
const [positionSecManagerOpen, setPositionSecManagerOpen] = useState(false);
const [selectedCategory, setSelectedCategory] = useState(null);
    // State variables
const [editingCategory, setEditingCategory] = useState(null);
const [categoryError, setCategoryError] = useState({});

const [prodectImageUpload, setProdectImageUpload] = useState(false);

const [sizes, setSizes] = useState([]);
const [extras, setExtras] = useState([]);
const [sizeDialogOpen, setSizeDialogOpen] = useState(false);
const [extraDialogOpen, setExtraDialogOpen] = useState(false);
const [editingSize, setEditingSize] = useState(null);
const [editingExtra, setEditingExtra] = useState(null);
const [sizeForm, setSizeForm] = useState({
  id: '',
  name: '',
  name_ar: '',
  name_en: '',
  price: 0
});
const [extraForm, setExtraForm] = useState({
  id: '',
  name: '',
  name_ar: '',
  name_en: '',
  description: '',
  description_ar: '',
  description_en: '',
  price: 0
});

// Online Tables Card with Live Updates
const [onlineTablesData, setOnlineTablesData] = useState({
  total: 0,
  playing: 0,
  waiting: 0,
  vip: 0,
  tables: []
});

// Listen for socket updates
useEffect(() => {
  if (!socket) return;
  
  // Listen for online tables updates
  socket.on('onlineTablesUpdate', (data) => {
    setOnlineTablesData({
      total: data.total,
      playing: data.tables?.filter(t => t.isPlaying).length || 0,
      waiting: data.tables?.filter(t => t.isWaiting).length || 0,
      vip: data.tables?.filter(t => t.isVip).length || 0,
      tables: data.tables || []
    });
  });
  
  // Request initial data
  socket.emit('getOnlinePlayers');
  
  return () => {
    socket.off('onlineTablesUpdate');
  };
}, [socket]);


// Size handlers
const handleOpenSizeDialog = (size = null) => {
  if (size) {
    setEditingSize(size);
    setSizeForm({
      id: size.id || `size_${Date.now()}`,
      name: size.name || `size_${Math.floor(1000000000 + Math.random() * 9000000000)}`,
      name_ar: size.name_ar || '',
      name_en: size.name_en || '',
      price: size.price || 0
    });
  } else {
    setEditingSize(null);
    setSizeForm({
      id: `size_${Date.now()}`,
      name: `size_${Math.floor(1000000000 + Math.random() * 9000000000)}`,
      name_ar: '',
      name_en: '',
      price: 0
    });
  }
  setSizeDialogOpen(true);
};

const handleCloseSizeDialog = () => {
  setSizeDialogOpen(false);
  setEditingSize(null);
};

const handleSaveSize = () => {
  if (!sizeForm.name_ar || !sizeForm.name_en || sizeForm.price === '') {
    alert(language === 'ar' ? 'يرجى ملء جميع الحقول المطلوبة' : 'Please fill all required fields');
    return;
  }

  if (editingSize) {
    // Update existing size
    setSizes(sizes.map(s => s.id === editingSize.id ? sizeForm : s));
  } else {
    // Add new size
    setSizes([...sizes, sizeForm]);
  }
  handleCloseSizeDialog();
};

const handleDeleteSize = (sizeId) => {
  if (window.confirm(language === 'ar' ? 'هل أنت متأكد من حذف هذا المقاس؟' : 'Are you sure you want to delete this size?')) {
    setSizes(sizes.filter(s => s.id !== sizeId));
  }
};

// Extra handlers
const handleOpenExtraDialog = (extra = null) => {
  if (extra) {
    setEditingExtra(extra);
    setExtraForm({
      id: extra.id || `extra_${Date.now()}`,
      name: extra.name || `extra_${Math.floor(1000000000 + Math.random() * 9000000000)}`,
      name_ar: extra.name_ar || '',
      name_en: extra.name_en || '',
      description: extra.description || '',
      description_ar: extra.description_ar || '',
      description_en: extra.description_en || '',
      price: extra.price || 0
    });
  } else {
    setEditingExtra(null);
    setExtraForm({
      id: `extra_${Date.now()}`,
      name: `extra_${Math.floor(1000000000 + Math.random() * 9000000000)}`,
      name_ar: '',
      name_en: '',
      description: '',
      description_ar: '',
      description_en: '',
      price: 0
    });
  }
  setExtraDialogOpen(true);
};

const handleCloseExtraDialog = () => {
  setExtraDialogOpen(false);
  setEditingExtra(null);
};

const handleSaveExtra = () => {
  if (!extraForm.name_ar || !extraForm.name_en || extraForm.price === '') {
    alert(language === 'ar' ? 'يرجى ملء جميع الحقول المطلوبة' : 'Please fill all required fields');
    return;
  }

  if (editingExtra) {
    // Update existing extra
    setExtras(extras.map(e => e.id === editingExtra.id ? extraForm : e));
  } else {
    // Add new extra
    setExtras([...extras, extraForm]);
  }
  handleCloseExtraDialog();
};

const handleDeleteExtra = (extraId) => {
  if (window.confirm(language === 'ar' ? 'هل أنت متأكد من حذف هذه الإضافة؟' : 'Are you sure you want to delete this extra?')) {
    setExtras(extras.filter(e => e.id !== extraId));
  }
};

// Handle edit category
const handleEditCategory = (category) => {
  setCategoryForm({
    name: category.name,
    description: category.description || '',
    name_en: category.name_en,
    description_en: category.description_en || '',
    card_limit: category.card_limit || 0,
    ico: category.ico || ''
  });
  setEditingCategory(category);
  setCategoryError({});
};

// Handle cancel edit
const handleCancelEdit = () => {
  setCategoryForm({ name: '', description: '' , name_en: '' , description_en: '', card_limit: 0, ico:'' });
  setEditingCategory(null);
  setCategoryError({});
};

// Handle update category
const handleUpdateCategory = async () => {
  try {
    // Validate
    const errors = {};
    if (!categoryForm.name.trim()) errors.name = 'Category name is required';
    if (Object.keys(errors).length > 0) {
      setCategoryError(errors);
      return;
    }

    const response = await api.put(`/categories/${editingCategory.id}`, categoryForm);
    
    // Update local state
    setCategories(prev => prev.map(cat => 
      cat.id === editingCategory.id ? response.data : cat
    ));
    
    setMessage({ type: 'success', text: 'Category updated successfully!' });
    handleCancelEdit();
  } catch (error) {
    setMessage({ 
      type: 'error', 
      text: error.response?.data?.message || 'Failed to update category' 
    });
  }
};

// Handle delete category
const handleDeleteCategory = async (categoryId) => {
  if (!window.confirm('Are you sure you want to delete this category? Products in this category will not be deleted.')) {
    return;
  }

  try {
    await api.delete(`/categories/${categoryId}`);
    
    // Update local state
    setCategories(prev => prev.filter(cat => cat.id !== categoryId));
    
    setMessage({ type: 'success', text: 'Category deleted successfully!' });
    
    // If we were editing this category, cancel edit
    if (editingCategory?.id === categoryId) {
      handleCancelEdit();
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to delete category';
    
    if (error.response?.status === 409) {
      // Category has associated products
      setMessage({ 
        type: 'error', 
        text: `${errorMessage} Please reassign or delete the products first.` 
      });
    } else {
      setMessage({ type: 'error', text: errorMessage });
    }
  }
};

// Update your existing handleAddCategory to reset form
const handleAddCategory = async () => {
  try {
    // Validate
    const errors = {};
    if (!categoryForm.name.trim()) errors.name = 'Category name is required';
    if (Object.keys(errors).length > 0) {
      setCategoryError(errors);
      return;
    }

    const response = await api.post('/categories', categoryForm);
    setCategories(prev => [...prev, response.data]);
    setMessage({ type: 'success', text: 'Category added successfully!' });
    
    // Reset form
    setCategoryForm({ name: '', description: '' , name_en: '' , description_en: '', card_limit: 0, ico: ''});
    setCategoryError({});
  } catch (error) {
    setMessage({ 
      type: 'error', 
      text: error.response?.data?.message || 'Failed to add category' 
    });
  }
};

  const [message, setMessage] = useState({ type: '', text: '' });
const [categories, setCategories] = useState([]);
const [categoryForm, setCategoryForm] = useState({
  name: '',
  description: '',
  name_en: '',
  description_en: '',
  card_limit: 0,
  ico:''
});
  const [settings, setSettings] = useState({
    points_per_100_EGP: '',
    point_value_in_EGP: '',
    deliver_value_in_EGP: '',
    service_charge_percent: '',
    threshold_min_amount: '',
    threshold_discount_value: '',
    deliver_status: 0
  });
const [searchTerm, setSearchTerm] = useState('');
const [summaryData, setSummaryData] = useState({
  totalUsers: 0,
  monthlySales: 0,
  pendingOrders: 0,
  outOfStock: 0
});

// State variables
const [transactionType, setTransactionType] = useState('payment');
const [customerPoints, setCustomerPoints] = useState(null);
const [pointsForm, setPointsForm] = useState({
  wallet_id: '',
  points_to_exchange: 0
});
  // Fetch current settings
  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/settings');
      const settingsData = {};
      
      response.data.forEach(setting => {
        settingsData[setting.key] = setting.value;
      });
      
      setSettings({
        deliver_status:settingsData.deliver_status || 0,
        points_per_100_EGP: settingsData.points_per_100_EGP || '',
        point_value_in_EGP: settingsData.point_value_in_EGP || '',
        deliver_value_in_EGP: settingsData.deliver_value_in_EGP || '',
        service_charge_percent: settingsData.service_charge_percent || '',
        threshold_min_amount: settingsData.threshold_min_amount || '',
        threshold_discount_value: settingsData.threshold_discount_value || ''
      });
    } catch (error) {
      console.error('Error fetching settings:', error);
      setMessage({ type: 'error', text: 'Failed to load settings' });
    } finally {
      setLoading(false);
    }
  };
// Fetch customer points when wallet ID changes
useEffect(() => {
  const fetchCustomerPoints = async () => {
    if (pointsForm.wallet_id && pointsForm.wallet_id.length > 3) {
      try {
        const response = await api.get(`/admin/customer-points/${pointsForm.wallet_id}`);
        setCustomerPoints(response.data);
      } catch (error) {
        console.error('Error fetching customer points:', error);
        setCustomerPoints(null);
      }
    }
  };

  const debounceTimer = setTimeout(fetchCustomerPoints, 500);
  return () => clearTimeout(debounceTimer);
}, [pointsForm.wallet_id]);

// Handle points form changes
const handlePointsChange = (e) => {
  const { name, value } = e.target;
  setPointsForm(prev => ({
    ...prev,
    [name]: name === 'points_to_exchange' ? parseInt(value) || 0 : value
  }));
};

// Handle points exchange submission
const handlePointsExchange = async (e) => {
  e.preventDefault();
  try {
    const response = await api.post('/admin/exchange-points', {
      wallet_id: pointsForm.wallet_id,
      points: pointsForm.points_to_exchange
    });
    
    setMessage({ type: 'success', text: `Successfully exchanged ${pointsForm.points_to_exchange} points for $${(pointsForm.points_to_exchange * pointsData.pointValue).toFixed(2)}` });
    
    // Reset form
    setPointsForm({
      wallet_id: '',
      points_to_exchange: 0
    });
    setCustomerPoints(null);
    
  } catch (error) {
    setMessage({ type: 'error', text: error.response?.data?.message || 'Points exchange failed' });
  }
};

// Add to your component state
const [paymentForm, setPaymentForm] = useState({
  wallet_id: '',
  amount: '',
  payment_method: 'cash'
});

  const [loadingMore, setLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
  const [searchTimeout, setSearchTimeout] = useState(null);

  // Update initial form state
const [formData, setFormData] = useState({
  is_active: true,
  product_pos: 0,
  name: '',
  description: '',
  name_en: '',
  description_en: '',
  price: '',
  quantity: '',
  category_id: '',
  imageUrl: '',
  discount_percent: 0,
  discount_start_date: '',
  discount_end_date: '',
  has_sizes: false,
  has_extras: false,
  sizes: [],
  extras: [],
  has_promotion: false,
  promotion_description: '',
  promotion_description_en:'',
  promotion_threshold:0,
  promotion_reward_type:'product',
  promotion_reward_id:null,
  promotion_reward_name: '',
  promotion_reward_value:0,
  promotion_start_date:'',
  promotion_end_date:'',
  promotion_max_uses:0,
  printer_ids:[],
  product_limit:0,
  kcal:0
});

// Update handleEdit function
const handleEdit = (product) => {
  setFormData({
    is_active: product.is_active,
    product_pos:product.product_pos || 0,
    name: product.name,
    description: product.description,
    name_en: product.name_en,
    description_en: product.description_en,
    price: product.price,
    quantity: product.quantity,
    category_id: product.category_id,
    imageUrl: product.imageUrl,
    discount_percent: product.discount_percent || 0,
    discount_start_date: product.discount_start_date 
      ? new Date(product.discount_start_date).toISOString().slice(0, 16)
      : '',
    discount_end_date: product.discount_end_date 
      ? new Date(product.discount_end_date).toISOString().slice(0, 16)
      : '',
    has_sizes: product.has_sizes,
    has_extras: product.has_extras ,
    sizes:product.sizes,
    extras:product.extras,
    has_promotion: product.has_promotion,
    promotion_description: product.promotion_description || '',
    promotion_description_en:product.promotion_description_en || '' ,
    promotion_threshold:product.promotion_threshold || 0,
    promotion_reward_type:product.promotion_reward_type || 'product',
    promotion_reward_id:product.promotion_reward_id || null,
    promotion_reward_name:product.promotion_reward_name || '',
    promotion_reward_value:product.promotion_reward_value || 0,
    promotion_start_date:product.promotion_start_date ||'',
    promotion_end_date:product.promotion_end_date || '',
    promotion_max_uses:product.promotion_max_uses || 0,
    printer_ids:product.printer_ids || [],
    product_limit:product.product_limit || 0,
    kcal:product.kcal || 0
  });
  setSizes(product.sizes || []);
  setExtras(product.extras || []);
  setEditingId(product.id);
};

// Update resetForm function
const resetForm = () => {
  setFormData({
    is_active: true,
    product_pos:0,
    name: '',
    description: '',
    name_en: '',
    description_en: '',
    price: '',
    quantity: '',
    category_id: '',
    imageUrl: '',
    discount_percent: 0,
    discount_start_date: '',
    discount_end_date: '',
    has_sizes: false,
    has_extras: false,
    sizes: [],
    extras: [],
    has_promotion: false,
    promotion_description: '',
    promotion_description_en:'',
    promotion_threshold:0,
    promotion_reward_type:'product',
    promotion_reward_id:null,
    promotion_reward_value:0,
    promotion_reward_name:'',
    promotion_start_date:'',
    promotion_end_date:'',
    promotion_max_uses:0,
    printer_ids:[],
    product_limit:0,
    kcal:0
  });
  
setSizes([]);
setExtras([]);
setSizeDialogOpen(false);
setExtraDialogOpen(false);
setEditingSize(null);
setEditingExtra(null);
setSizeForm({
  id: '',
  name: '',
  name_ar: '',
  name_en: '',
  price: 0
});
setExtraForm({
  id: '',
  name: '',
  name_ar: '',
  name_en: '',
  description: '',
  description_ar: '',
  description_en: '',
  price: 0
});

  setEditingId(null);
};

const fetchAllProducts = useCallback(async () => {
  setLoadingProducts(true);
  try {
    const response = await api.get('/products/all_products', {
      params: { lang: language }
    });
    
    if (response.data && response.data.products) {
      setAllProducts(response.data.products);
    } else {
      setAllProducts([]);
    }
  } catch (error) {
    console.error('Error fetching all products:', error);
    // Show error message
    setAllProducts([]);
  } finally {
    setLoadingProducts(false);
  }
}, [language]);

  // Fetch products with pagination and search
  const fetchProducts = useCallback(async (page = 1, search = '') => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', 9);
      if (search) {
        params.append('search', search);
        params.append('lang', language);
      }
      
      const response = await api.get(`/products?${params}`);
      
      setProducts(response.data.products);
      setCurrentPage(response.data.pagination.currentPage);
      setTotalPages(response.data.pagination.totalPages);
      setTotalProducts(response.data.pagination.totalProducts);
    } catch (error) {
      console.error('Error fetching products:', error);
      setMessage({ type: 'error', text: 'Failed to fetch products' });
    } finally {
      setLoading(false);
    }
  }, [language]);

  // Initial load
  useEffect(() => {
    fetchProducts(1);
    if (formData.promotion_reward_type === 'product') {
      fetchAllProducts();
    }
  }, [fetchProducts]);

  // Handle search with debounce
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Set new timeout for debounced search
    setSearchTimeout(setTimeout(() => {
      fetchProducts(1, value);
    }, 500)); // 500ms debounce
  };

  // Handle page change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    fetchProducts(value, searchTerm);
  };



const handlePaymentChange = (e) => {
  setPaymentForm({
    ...paymentForm,
    [e.target.name]: e.target.value
  });
};

const handlePaymentSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await api.post('/payment/process', paymentForm);
    setMessage({
      type: 'success',
      text: `Payment processed! Customer earned ${response.data.points_earned} points`
    });
    setPaymentForm({
      wallet_id: '',
      amount: '',
      payment_method: 'cash'
    });
  } catch (error) {
    setMessage({
      type: 'error',
      text: error.response?.data?.error || 'Payment processing failed'
    });
  }
};

const fetchSummaryData = async () => {
  try {
    const response = await api.get('/admin/summary');
    setSummaryData(response.data);
  } catch (error) {
    console.error('Error fetching summary data:', error);
  }
};

  // Handle product delete
  const handleDelete = async (id) => {
    try {
      await api.delete(`/admin/products/${id}`);
      setMessage({ type: 'success', text: 'Product deleted successfully!' });
      // Refresh current page after deletion
      fetchProducts(currentPage, searchTerm);
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.message || 'Delete failed' });
    }
  };

const fetchCategories = async () => {
  try {
    const response = await api.get('/categories');
    setCategories(response.data);
    setLoading(false);
  } catch (error) {
    console.error('Error fetching categories:', error);
    setLoading(false);
  }
};

useEffect(() => {
  const loadData = async () => {
    await fetchProducts();
    await fetchCategories();
    await fetchSummaryData();
    await fetchPaymentPoints();
    await fetchPointsData();
    await fetchSettings();
  };
  window.scrollTo({
      top: 0,
      behavior: 'smooth' // Adds smooth scrolling animation
  });

  loadData();
}, []);

  const handleChangeSettings = (key) => (e) => {
    if(key === 'deliver_status') {
      const newValue = e.target.checked ? '1' : '0';
      setSettings(prev => ({
        ...prev,
        [key]: newValue
      }));
    } else {
      setSettings(prev => ({
        ...prev,
        [key]: e.target.value
      }));
    }
  };

  const handleSubmitSettings = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      // Update each setting
      const updates = Object.entries(settings).map(([key, value]) =>
        api.put('/admin/settings', { key, value })
      );

      await Promise.all(updates);
      
      setMessage({ type: 'success', text: 'Settings updated successfully!' });
    } catch (error) {
      console.error('Error updating settings:', error);
      setMessage({ type: 'error', text: 'Failed to update settings' });
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
    const loadData = async () => {
      await fetchSalesData();
      await fetchPaymentPoints();
      await fetchPrinters();
    };

    loadData();
}, [timeRange, year]);

const fetchPrinters = async () => {
  setPrintersLoading(true);
  try {
    const response = await api.get('/admin/printers');
    setPrinters(response.data.printers || []);
  } catch (error) {
    console.error('Error fetching printers:', error);
  } finally {
    setPrintersLoading(false);
  }
};
// State declarations
const [visibleCards, setVisibleCards] = useState({
  monthlySales: false,
  weeklySales: false,
  dailySales: false,
  totalOrders: false,
  // add more as needed
});

// Toggle function
const toggleVisibility = (cardName) => {
  setVisibleCards(prev => ({
    ...prev,
    [cardName]: !prev[cardName]
  }));
};
  const fetchPointsData = async () => {
    try {
      const response = await api.get(`/payment/settings`);
      setPointsData(response.data);
    } catch (error) {
      console.error('Error fetching sales data:', error);
    }
  };

  const fetchSalesData = async () => {
    try {
      const response = await api.get(`/sales?range=${timeRange}&year=${year}`);
      setSalesData(response.data);
    } catch (error) {
      console.error('Error fetching sales data:', error);
    }
  };

  const fetchPaymentPoints = async () => {
    try {
      const response = await api.get(`/payment-points?range=${timeRange}&year=${year}`);
      setPaymentPoints(response.data);
    } catch (error) {
      console.error('Error fetching payment points:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  const productData = {
    is_active:formData.is_active,
    product_pos:formData.product_pos,
    name: formData.name,
    description: formData.description,
    name_en: formData.name_en,
    description_en: formData.description_en,
    price: parseFloat(formData.price),
    quantity: parseInt(formData.quantity),
    category_id: formData.category_id,
    imageUrl: formData.imageUrl,
    discount_percent: parseInt(formData.discount_percent) || 0,
    discount_start_date: formData.discount_start_date || null,
    discount_end_date: formData.discount_end_date || null,
    has_sizes: sizes.length > 0,
    has_extras: extras.length > 0,
    sizes: sizes,
    extras: extras,
    has_promotion: formData.has_promotion,
    promotion_description: formData.promotion_description || '',
    promotion_description_en: formData.promotion_description_en || '',
    promotion_threshold: formData.promotion_threshold || 0,
    promotion_reward_type:formData.promotion_reward_type || 'product',
    promotion_reward_id:formData.promotion_reward_id || null,
    promotion_reward_name:formData.promotion_reward_name || '',
    promotion_reward_value:formData.promotion_reward_value || 0,
    promotion_start_date:formData.promotion_start_date || '',
    promotion_end_date:formData.promotion_end_date || '',
    promotion_max_uses:formData.promotion_max_uses || 0,
    printer_ids: formData.printer_ids || [],
    product_limit:formData.product_limit || 0,
    kcal: formData.kcal || 0
  };

    try {
      if (editingId) {
        await api.put(`/admin/products/${editingId}`, productData);
        setMessage({ type: 'success', text: 'Product updated successfully!' });
      } else {
        await api.post('/admin/products', productData);
        setMessage({ type: 'success', text: 'Product added successfully!' });
      }
      fetchProducts(currentPage);
      resetForm();
    } catch (error) {
      setMessage({ type: 'error', text: error.response?.data?.message || 'Operation failed' });
    }
  };


  const getTopProducts = () => {
    return [...products]
      .sort((a, b) => b.salesCount - a.salesCount)
      .slice(0, 5)
      .map(product => ({
        name: language === 'ar' ? product.name:product.name_en,
        value: product.salesCount || 0
      }));
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 , mb: 10}}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        {language === 'ar' ? 'لوحة التحكم' : 'Dashboard'}
      </Typography>

      {message.text && (
        <Alert severity={message.type} sx={{ mb: 3 }}>
          {message.text}
        </Alert>
      )}
{/* Summary Cards Section */}
<Grid container spacing={3} sx={{ mb: 4 }}>
  {/* Total Users Card */}
  <Grid item xs={12} sm={6} md={3}>
    <Card 
      elevation={0}
      sx={{ 
        ...cardStyles,
        background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #FFD700, #FFE55C)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#B3B3B3', fontWeight: 500, mb: 1 }}>
              {language === 'ar' ? 'عدد المستخدمين' : 'Total Users'}
            </Typography>
            <Typography variant="h3" sx={{ color: '#FFD700', fontWeight: 800 }}>
              {summaryData?.totalUsers || 0}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: 'rgba(255, 215, 0, 0.1)', 
              color: '#FFD700',
              width: 48,
              height: 48
            }}
          >
            <PeopleIcon />
          </Avatar>
        </Box>
        <Button
          fullWidth
          variant="outlined"
          endIcon={language === 'ar' ? <ArrowBackIcon /> : <ArrowForwardIcon />}
          onClick={() => navigate(`/admin/users`)}
          sx={{
            mt: 2,
            borderColor: '#FFD700',
            color: '#FFD700',
            borderRadius: '12px',
            '&:hover': {
              borderColor: '#FFE55C',
              backgroundColor: 'rgba(255, 215, 0, 0.1)',
              transform: 'translateX(4px)',
            }
          }}
        >
          {language === 'ar' ? 'عرض المستخدمين' : 'View Users'}
        </Button>
      </CardContent>
    </Card>
  </Grid>

  {/* Total Tables Card */}
  <Grid item xs={12} sm={6} md={3}>
    <Card 
      elevation={0}
      sx={{ 
        ...cardStyles,
        background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #FFD700, #FFE55C)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#B3B3B3', fontWeight: 500, mb: 1 }}>
              {language === 'ar' ? 'الطاولات' : 'Tables'}
            </Typography>
            <Typography variant="h3" sx={{ color: '#FFD700', fontWeight: 800 }}>
              {summaryData?.totalTables || 0}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: 'rgba(255, 215, 0, 0.1)', 
              color: '#FFD700',
              width: 48,
              height: 48
            }}
          >
            <TableRestaurantIcon />
          </Avatar>
        </Box>
        <Button
          fullWidth
          variant="outlined"
          endIcon={language === 'ar' ? <ArrowBackIcon /> : <ArrowForwardIcon />}
          onClick={() => navigate(`/admin/cafetables`)}
          sx={{
            mt: 2,
            borderColor: '#FFD700',
            color: '#FFD700',
            borderRadius: '12px',
            '&:hover': {
              borderColor: '#FFE55C',
              backgroundColor: 'rgba(255, 215, 0, 0.1)',
              transform: 'translateX(4px)',
            }
          }}
        >
          {language === 'ar' ? 'إدارة الطاولات' : 'Manage Tables'}
        </Button>
      </CardContent>
    </Card>
  </Grid>

<Grid item xs={12} sm={6} md={3}>
  <Card 
    elevation={0}
    sx={{ 
      ...cardStyles,
      background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
      position: 'relative',
      overflow: 'hidden',
      height: '180px',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #FFD700, #FFE55C)',
      },
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 8px 24px rgba(255, 215, 0, 0.15)',
      }
    }}
    onClick={() => navigate(`/admin/games`)}
  >
    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 }, height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
        <Box>
          <Typography variant="caption" sx={{ color: '#B3B3B3', fontWeight: 500, display: 'block', fontSize: '0.7rem' }}>
            {language === 'ar' ? 'الطاولات النشطة' : 'Online Tables'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
            <Typography variant="h5" sx={{ color: '#FFD700', fontWeight: 800, fontSize: '1.5rem', lineHeight: 1.2 }}>
              {onlineTablesData.total}
            </Typography>
            <Chip 
              size="small"
              label={socket?.connected ? 'Live' : 'Offline'}
              sx={{
                backgroundColor: socket?.connected ? 'rgba(76, 175, 80, 0.2)' : 'rgba(244, 67, 54, 0.2)',
                color: socket?.connected ? '#4CAF50' : '#F44336',
                height: 16,
                fontSize: '0.5rem',
                fontWeight: 600
              }}
            />
          </Box>
        </Box>
        <Avatar 
          sx={{ 
            bgcolor: 'rgba(255, 215, 0, 0.1)', 
            color: '#FFD700',
            width: 36,
            height: 36,
          }}
        >
          <SportsEsportsIcon sx={{ fontSize: 20 }} />
        </Avatar>
      </Box>
      
      {/* Stats Row - Compact */}
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', my: 0.5 }}>
        <Box sx={{ textAlign: 'center', flex: 1 }}>
          <Typography variant="caption" sx={{ color: '#888888', fontSize: '0.6rem' }}>
            {language === 'ar' ? 'لعب' : 'Play'}
          </Typography>
          <Typography variant="body2" sx={{ color: '#4CAF50', fontWeight: 700, fontSize: '0.85rem', lineHeight: 1.2 }}>
            {onlineTablesData.playing}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ backgroundColor: '#2D2D2D' }} />
        <Box sx={{ textAlign: 'center', flex: 1 }}>
          <Typography variant="caption" sx={{ color: '#888888', fontSize: '0.6rem' }}>
            {language === 'ar' ? 'انتظار' : 'Wait'}
          </Typography>
          <Typography variant="body2" sx={{ color: '#42A5F5', fontWeight: 700, fontSize: '0.85rem', lineHeight: 1.2 }}>
            {onlineTablesData.waiting}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ backgroundColor: '#2D2D2D' }} />
        <Box sx={{ textAlign: 'center', flex: 1 }}>
          <Typography variant="caption" sx={{ color: '#888888', fontSize: '0.6rem' }}>
            VIP
          </Typography>
          <Typography variant="body2" sx={{ color: '#FF9800', fontWeight: 700, fontSize: '0.85rem', lineHeight: 1.2 }}>
            {onlineTablesData.vip}
          </Typography>
        </Box>
      </Box>
      
      {/* Mini Activity Bar */}
      {onlineTablesData.total > 0 && (
        <LinearProgress 
          variant="determinate" 
          value={(onlineTablesData.playing / onlineTablesData.total) * 100}
          sx={{
            backgroundColor: '#1A1A1A',
            borderRadius: 10,
            height: 2,
            mb: 0.5,
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#FFD700',
            }
          }}
        />
      )}
      
      {/* Compact Button */}
      <Button
        size="small"
        fullWidth
        variant="outlined"
        endIcon={language === 'ar' ? <ArrowBackIcon sx={{ fontSize: 14 }} /> : <ArrowForwardIcon sx={{ fontSize: 14 }} />}
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/admin/games`);
        }}
        sx={{
          mt: 0.5,
          py: 0.5,
          borderColor: '#FFD700',
          color: '#FFD700',
          borderRadius: '8px',
          fontSize: '0.7rem',
          minHeight: '45px',
          '&:hover': {
            borderColor: '#FFE55C',
            backgroundColor: 'rgba(255, 215, 0, 0.1)',
          }
        }}
      >
        {language === 'ar' ? 'عرض' : 'View'}
      </Button>
    </CardContent>
  </Card>
</Grid>

  {/* Monthly Sales Card */}
  <Grid item xs={12} sm={6} md={3}>
    <Card 
      elevation={0}
      sx={{ 
        ...cardStyles,
        background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #FFD700, #FFE55C)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#B3B3B3', fontWeight: 500, mb: 1 }}>
              {language === 'ar' ? 'مبيعات هذا الشهر' : 'Monthly Sales'}
            </Typography>
            <Typography variant="h3" sx={{ color: '#FFD700', fontWeight: 800 }}>
              {visibleCards.monthlySales ? (
                `${summaryData?.monthlySales?.toFixed(2) || 0}`
              ) : (
                '••••••'
              )}
            </Typography>
            {visibleCards.monthlySales && (
              <Typography variant="caption" sx={{ color: '#4CAF50', mt: 1, display: 'block' }}>
                {language === 'ar' ? 'إجمالي المبيعات' : 'Total Revenue'}
              </Typography>
            )}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
            <Avatar 
              sx={{ 
                bgcolor: 'rgba(255, 215, 0, 0.1)', 
                color: '#FFD700',
                width: 48,
                height: 48
              }}
            >
              <AttachMoneyIcon />
            </Avatar>
            <IconButton 
              size="small" 
              onClick={() => toggleVisibility('monthlySales')}
              sx={{ 
                color: '#B3B3B3',
                bgcolor: 'rgba(255, 215, 0, 0.05)',
                '&:hover': { color: '#FFD700', bgcolor: 'rgba(255, 215, 0, 0.1)' }
              }}
            >
              {visibleCards.monthlySales ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
            </IconButton>
          </Box>
        </Box>
      </CardContent>
    </Card>
  </Grid>

  {/* Pending Orders Card */}
  <Grid item xs={12} sm={6} md={3}>
    <Card 
      elevation={0}
      sx={{ 
        ...cardStyles,
        background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #FFD700, #FFE55C)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#B3B3B3', fontWeight: 500, mb: 1 }}>
              {language === 'ar' ? 'طلبات معلقة' : 'Pending Orders'}
            </Typography>
            <Typography variant="h3" sx={{ color: '#FF9800', fontWeight: 800 }}>
              {summaryData?.pendingOrders || 0}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: 'rgba(255, 152, 0, 0.1)', 
              color: '#FF9800',
              width: 48,
              height: 48
            }}
          >
            <PendingIcon />
          </Avatar>
        </Box>
        <Button
          fullWidth
          variant="outlined"
          endIcon={language === 'ar' ? <ArrowBackIcon /> : <ArrowForwardIcon />}
          onClick={() => navigate(`/admin/orders?status=pending`)}
          sx={{
            mt: 2,
            borderColor: '#FF9800',
            color: '#FF9800',
            borderRadius: '12px',
            '&:hover': {
              borderColor: '#FFB74D',
              backgroundColor: 'rgba(255, 152, 0, 0.1)',
              transform: 'translateX(4px)',
            }
          }}
        >
          {language === 'ar' ? 'عرض الطلبات' : 'View Orders'}
        </Button>
      </CardContent>
    </Card>
  </Grid>

  {/* Out of Stock Card */}
  <Grid item xs={12} sm={6} md={3}>
    <Card 
      elevation={0}
      sx={{ 
        ...cardStyles,
        background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #FF3D00, #FF6B3D)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#B3B3B3', fontWeight: 500, mb: 1 }}>
              {language === 'ar' ? 'نفذت الكمية' : 'Out of Stock'}
            </Typography>
            <Typography variant="h3" sx={{ color: '#FF3D00', fontWeight: 800 }}>
              {summaryData?.outOfStock || 0}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: 'rgba(255, 61, 0, 0.1)', 
              color: '#FF3D00',
              width: 48,
              height: 48
            }}
          >
            <WarningIcon />
          </Avatar>
        </Box>
        <Button
          fullWidth
          variant="outlined"
          endIcon={language === 'ar' ? <ArrowBackIcon /> : <ArrowForwardIcon />}
          onClick={() => setOutOfStockDialogOpen(true)}
          sx={{
            mt: 2,
            borderColor: '#FF3D00',
            color: '#FF3D00',
            borderRadius: '12px',
            '&:hover': {
              borderColor: '#FF6B3D',
              backgroundColor: 'rgba(255, 61, 0, 0.1)',
              transform: 'translateX(4px)',
            }
          }}
        >
          {language === 'ar' ? 'عرض المنتجات' : 'View Products'}
        </Button>
      </CardContent>
    </Card>
  </Grid>

  {/* Payment Settings Card */}
  <Grid item xs={12} sm={6} md={3}>
    <Card 
      elevation={0}
      sx={{ 
        ...cardStyles,
        background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #FFD700, #FFE55C)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#B3B3B3', fontWeight: 500, mb: 1 }}>
              {language === 'ar' ? 'إعدادات الدفع' : 'Payment Settings'}
            </Typography>
            <Typography variant="body2" sx={{ color: '#4CAF50' }}>
              {language === 'ar' ? 'بوابات الدفع' : 'Payment Gateways'}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: 'rgba(255, 215, 0, 0.1)', 
              color: '#FFD700',
              width: 48,
              height: 48
            }}
          >
            <PaymentIcon />
          </Avatar>
        </Box>
        <Button
          fullWidth
          variant="outlined"
          endIcon={language === 'ar' ? <ArrowBackIcon /> : <ArrowForwardIcon />}
          onClick={() => navigate(`/admin/PaymentSettings`)}
          sx={{
            mt: 2,
            borderColor: '#FFD700',
            color: '#FFD700',
            borderRadius: '12px',
            '&:hover': {
              borderColor: '#FFE55C',
              backgroundColor: 'rgba(255, 215, 0, 0.1)',
              transform: 'translateX(4px)',
            }
          }}
        >
          {language === 'ar' ? 'إدارة الإعدادات' : 'Manage Settings'}
        </Button>
      </CardContent>
    </Card>
  </Grid>

  {/* Printers Settings Card */}
  <Grid item xs={12} sm={6} md={3}>
    <Card 
      elevation={0}
      sx={{ 
        ...cardStyles,
        background: 'linear-gradient(135deg, #1A1A1A 0%, #0D0D0D 100%)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #FFD700, #FFE55C)',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#B3B3B3', fontWeight: 500, mb: 1 }}>
              {language === 'ar' ? 'الطابعات' : 'Printers'}
            </Typography>
            <Typography variant="body2" sx={{ color: '#4CAF50' }}>
              {language === 'ar' ? 'إعدادات الطباعة' : 'Print Configuration'}
            </Typography>
          </Box>
          <Avatar 
            sx={{ 
              bgcolor: 'rgba(255, 215, 0, 0.1)', 
              color: '#FFD700',
              width: 48,
              height: 48
            }}
          >
            <PrintIcon />
          </Avatar>
        </Box>
        <Button
          fullWidth
          variant="outlined"
          endIcon={language === 'ar' ? <ArrowBackIcon /> : <ArrowForwardIcon />}
          onClick={() => navigate(`/admin/adminprinters`)}
          sx={{
            mt: 2,
            borderColor: '#FFD700',
            color: '#FFD700',
            borderRadius: '12px',
            '&:hover': {
              borderColor: '#FFE55C',
              backgroundColor: 'rgba(255, 215, 0, 0.1)',
              transform: 'translateX(4px)',
            }
          }}
        >
          {language === 'ar' ? 'إدارة الطابعات' : 'Manage Printers'}
        </Button>
      </CardContent>
    </Card>
  </Grid>
</Grid>
      {/* Analytics Section */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {/* Sales Overview Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">{language === 'ar' ? 'نظرة عامة على المبيعات' : 'Sales Overview'}</Typography>
                <Box display="flex" gap={2}>
                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel>{language === 'ar' ? 'النطاق الزمني' : 'Time range'}</InputLabel>
                    <Select
                      value={timeRange}
                      onChange={(e) => setTimeRange(e.target.value)}
                      label={language === 'ar' ? 'النطاق الزمني' : 'Time range'}
                    >
                      <MenuItem value="monthly">{language === 'ar' ? 'شهري' : 'Monthly'}</MenuItem>
                      <MenuItem value="yearly">{language === 'ar' ? 'سنوي' : 'Yearly'}</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    size="small"
                    type="number"
                    label={language === 'ar' ? 'سنة' : 'Year'}
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    sx={{ width: 100 }}
                  />
                </Box>
              </Box>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={salesData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="period" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="sales" fill="#8884d8" name={language === 'ar' ? 'إجمالي المبيعات' : 'Total sales'} />
                  <Bar dataKey="transactions" fill="#82ca9d" name={language === 'ar' ? 'المعاملات' : 'Actions'} />
                </BarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* Payment Points Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {language === 'ar' ? 'مبيعات بالنقاط' : 'Points sales'}
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={paymentPoints}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="pointsUsed"
                    stroke="#ff7300"
                    name={language === 'ar' ? 'نقاط مستخدمة' : 'Points used'}
                  />
                  <Line
                    type="monotone"
                    dataKey="pointsPurchased"
                    stroke="#387908"
                    name={language === 'ar' ? 'النقاط المشتراة' : 'points purchased'}
                  />
                </LineChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* Top Products Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {language === 'ar' ? 'المنتجات الأكثر مبيعا' : 'Top selling products'}
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={getTopProducts()}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                    nameKey={language === 'ar' ? 'name' : 'name_en'}
                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  >
                    {getTopProducts().map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* Inventory Status Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {language === 'ar' ? 'حالة المخزون' : 'Stock status'}
              </Typography>
              <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography>
                  {language === 'ar' ? 'إجمالي المنتجات' : 'Total Products'} : <strong>{products.length}</strong>ر 
                </Typography>
                <Typography>
                  {language === 'ar' ? 'انخفاض المخزون' : 'Stock decrease'} : <strong color="error">
                    {products.filter(p => p.quantity < 10).length}
                  </strong>
                </Typography>
              </Box>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  data={products
                    .sort((a, b) => b.quantity - a.quantity)
                    .slice(0, 8)
                    .map(p => ({ name:language === 'ar' ? p.name : p.name_en, quantity: p.quantity }))
                  }
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="quantity" fill="#8884d8" name={language === 'ar' ? 'كمية المخزون' : 'Inventory quantity'} />
                </BarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Product Management Section */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {editingId ? editProductTitleTxt : addProductTitleTxt}
              </Typography>
              <Box component="form" onSubmit={handleSubmit}>
                             <FormControlLabel
      control={
        <Switch
          checked={formData.is_active}
          onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#FFD700',
            },
          }}
        />
      }
      label={language === 'ar' ? 'متاح' : 'Is Active'}
      sx={{ color: '#FFFFFF', mb: 2, display: 'block' }}
    />
                    <TextField
                  fullWidth
                  label={language === 'ar' ? 'رقم ظهور المنتج' : 'Postion ID'}
                  name="product_pos"
                  value={formData.product_pos}
                  onChange={handleChange}
                  type="number"
                  inputProps={{ min: 0, max: 100, step: 1 }}
                  helperText={language === 'ar' ? 'أدخل 0 للظهور العشوائي' : 'Enter 0 for random show'}
                  required
                />
<Button
  startIcon={<DragIcon />}
  onClick={() => {
    setPositionManagerOpen(true);
  }}
  sx={{ color: '#FFD700' }}
>
  {language === 'ar' ? 'ترتيب المنتجات' : 'Reorder Products'}
</Button>
                <TextField
                  fullWidth
                  margin="normal"
                  label={language === 'ar' ? 'إسم المنتج عربي' : 'Product Name (AR)'}
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label={language === 'ar' ? 'الوصف عربي' : 'Description (AR)'}
                  name="description"
                  multiline
                  rows={3}
                  value={formData.description}
                  onChange={handleChange}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label={language === 'ar' ? 'إسم المنتج إنجليزي' : 'Product Name (EN)'}
                  name="name_en"
                  value={formData.name_en}
                  onChange={handleChange}
                  required
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label={language === 'ar' ? 'الوصف إنجليزي' : 'Description (EN)'}
                  name="description_en"
                  multiline
                  rows={3}
                  value={formData.description_en}
                  onChange={handleChange}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label={language === 'ar' ? 'السعر' : 'Price'}
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  required
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label={language === 'ar' ? 'كمية المخزون' : 'Stock quantity'}
                  type="number"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  required
                />
      <FormControl fullWidth margin="normal">
        <InputLabel id="category-select-label">{language === 'ar' ? 'القسم' : 'Section'}</InputLabel>
        <Select
          labelId="category-select-label"
          id="category-select"
          name="category_id"
          value={formData.category_id}
          label={language === 'ar' ? 'القسم' : 'Section'}
          onChange={handleChange}
          required
        >
          {loading ? (
            <MenuItem disabled>{language === 'ar' ? 'جار تحميل الأقسام ...' : 'Loading sections...'}</MenuItem>
          ) : (
            categories.map(category => (
              <MenuItem key={category.id} value={category.id}>
                {language === 'ar' ? category.name : category.name_en}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>{/* Printer Selection Dropdown - Multi Select */}
<FormControl fullWidth margin="normal">
  <InputLabel id="printer-select-label">{language === 'ar' ? 'الطابعات' : 'Printers'}</InputLabel>
  <Select
    labelId="printer-select-label"
    id="printer-select"
    name="printer_ids"
    multiple
    value={formData.printer_ids || []}
    label={language === 'ar' ? 'الطابعات' : 'Printers'}
    onChange={handleChange}
    renderValue={(selected) => (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {selected.map((value) => {
          const printer = printers.find(p => p.id === value);
          return (
            <Chip 
              key={value} 
              label={language === 'ar' ? printer?.name_ar || printer?.name : printer?.name}
              size="small"
              sx={{ 
                backgroundColor: '#FFD700', 
                color: '#000000',
                fontWeight: 500,
                '& .MuiChip-deleteIcon': {
                  color: '#000000',
                  '&:hover': { color: '#FF3D00' }
                }
              }}
              onDelete={() => {
                const newSelected = (formData.printer_ids || []).filter(id => id !== value);
                handleChange({ target: { name: 'printer_ids', value: newSelected } });
              }}
              deleteIcon={<CloseIcon />}
            />
          );
        })}
        {selected.length === 0 && (
          <Typography sx={{ color: '#B3B3B3', fontSize: '0.875rem' }}>
            {language === 'ar' ? 'اختر الطابعات' : 'Select printers'}
          </Typography>
        )}
      </Box>
    )}
    MenuProps={{
      PaperProps: {
        sx: {
          backgroundColor: '#0D0D0D',
          border: '1px solid #FFD700',
          maxHeight: 300,
          '& .MuiMenuItem-root': {
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: 'rgba(255, 215, 0, 0.1)',
            },
            '&.Mui-selected': {
              backgroundColor: 'rgba(255, 215, 0, 0.2)',
              '&:hover': {
                backgroundColor: 'rgba(255, 215, 0, 0.3)',
              }
            }
          }
        }
      }
    }}
  >
    <MenuItem value="" disabled>
      <em>{language === 'ar' ? 'اختر طابعة أو أكثر' : 'Select one or more printers'}</em>
    </MenuItem>
    {printers.map(printer => (
      <MenuItem key={printer.id} value={printer.id}>
        <Checkbox 
          checked={(formData.printer_ids || []).indexOf(printer.id) > -1}
          sx={{ 
            color: '#B3B3B3',
            '&.Mui-checked': { color: '#FFD700' }
          }}
        />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <span>{language === 'ar' ? printer.name_ar || printer.name : printer.name}</span>
          <Chip 
            label={printer.printer_type} 
            size="small" 
            sx={{ 
              backgroundColor: '#2D2D2D', 
              color: '#FFD700',
              fontSize: '0.7rem',
              height: 20
            }} 
          />
          {printer.is_default && (
            <Chip 
              label={language === 'ar' ? 'افتراضي' : 'Default'} 
              size="small" 
              sx={{ 
                backgroundColor: '#4CAF50', 
                color: '#FFFFFF',
                fontSize: '0.7rem',
                height: 20
              }} 
            />
          )}
        </Box>
      </MenuItem>
    ))}
  </Select>
  <FormHelperText>
    {language === 'ar' 
      ? 'يمكنك اختيار أكثر من طابعة لطباعة طلبات هذا المنتج' 
      : 'You can select multiple printers for this product\'s orders'}
  </FormHelperText>
</FormControl>

{/* Display selected printers info */}
{(formData.printer_ids || []).length > 0 && (
  <Box sx={{ 
    p: 2, 
    bgcolor: '#1A1A1A', 
    borderRadius: '8px', 
    mb: 2,
    border: '1px solid #2D2D2D'
  }}>
    <Typography variant="caption" sx={{ color: '#B3B3B3', display: 'block', mb: 1 }}>
      {language === 'ar' ? 'الطابعات المحددة' : 'Selected Printers'}
    </Typography>
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {(formData.printer_ids || []).map(printerId => {
        const printer = printers.find(p => p.id === printerId);
        if (!printer) return null;
        return (
          <Paper
            key={printerId}
            elevation={0}
            sx={{
              p: 1.5,
              backgroundColor: '#0D0D0D',
              border: '1px solid #FFD700',
              borderRadius: '8px',
              minWidth: 180
            }}
          >
            <Typography variant="body2" sx={{ color: '#FFD700', fontWeight: 600, mb: 0.5 }}>
              {language === 'ar' ? printer.name_ar || printer.name : printer.name}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.5 }}>
              <Chip 
                label={`IP: ${printer.ip_address || 'N/A'}`}
                size="small"
                sx={{ bgcolor: '#1A1A1A', color: '#B3B3B3', height: 20, fontSize: '0.65rem' }}
              />
              <Chip 
                label={`Port: ${printer.port || 9100}`}
                size="small"
                sx={{ bgcolor: '#1A1A1A', color: '#B3B3B3', height: 20, fontSize: '0.65rem' }}
              />
              <Chip 
                label={language === 'ar' ? `نوع: ${printer.printer_type}` : `Type: ${printer.printer_type}`}
                size="small"
                sx={{ bgcolor: '#1A1A1A', color: '#B3B3B3', height: 20, fontSize: '0.65rem' }}
              />
            </Box>
          </Paper>
        );
      })}
    </Box>
  </Box>
)}
      <TextField
          fullWidth
          margin="normal"
          label={language === 'ar' ? 'نسبة الخصم' : 'Discount percentage'}
          type="number"
          name="discount_percent"
          value={formData.discount_percent}
          onChange={handleChange}
          inputProps={{ min: 0, max: 100, step: 1 }}
          helperText={language === 'ar' ? 'أدخل 0 لإزالة الخصم' : 'Enter 0 to remove the discount'}
        />
        <TextField
          fullWidth
          margin="normal"
          label={language === 'ar' ? 'اقصى حد' : 'Max card item'}
          type="number"
          name="product_limit"
          value={formData.product_limit}
          onChange={handleChange}
          inputProps={{ min: 0, max: 100, step: 1 }}
          helperText={language === 'ar' ? 'أدخل 0 لإزالة الحد' : 'Enter 0 to remove the max item'}
        />
        <TextField
          fullWidth
          margin="normal"
          label={language === 'ar' ? 'السعرات الحرارية' : 'Product Kcal'}
          type="number"
          name="kcal"
          value={formData.kcal}
          onChange={handleChange}
          inputProps={{ min: 0, max: 10000, step: 1 }}
          helperText={language === 'ar' ? 'أدخل 0 لإزالة السعرات' : 'Enter 0 to remove the kcal'}
        />
        {/* Discount Start Date */}
        <TextField
          fullWidth
          margin="normal"
          label={language === 'ar' ? 'تاريخ بدء الخصم' : 'Discount start date'}
          type="datetime-local"
          name="discount_start_date"
          value={formData.discount_start_date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
        
        {/* Discount End Date */}
        <TextField
          fullWidth
          margin="normal"
          label={language === 'ar' ? 'تاريخ نهاية الخصم' : 'Discount end date'}
          type="datetime-local"
          name="discount_end_date"
          value={formData.discount_end_date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />

        {/* Product Customization Options */}
<Accordion 
  sx={{ 
    mt: 2, 
    backgroundColor: '#1A1A1A',
    border: '1px solid #2D2D2D',
    borderRadius: '8px !important',
    '&:before': { display: 'none' }
  }}
>
  <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#FFD700' }} />}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <SizeIcon sx={{ color: '#FFD700' }} />
      <Typography sx={{ color: '#FFD700', fontWeight: 600 }}>
        {language === 'ar' ? 'خيارات المقاسات' : 'Size Options'}
      </Typography>
      {sizes.length > 0 && (
        <Chip 
          label={sizes.length} 
          size="small"
          sx={{ backgroundColor: '#FFD700', color: '#000000', fontWeight: 'bold' }}
        />
      )}
    </Box>
  </AccordionSummary>
  <AccordionDetails>
    <Box sx={{ mb: 2 }}>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={() => handleOpenSizeDialog()}
        sx={{
          borderColor: '#FFD700',
          color: '#FFD700',
          '&:hover': { borderColor: '#FFE55C', backgroundColor: 'rgba(255, 215, 0, 0.08)' }
        }}
      >
        {language === 'ar' ? 'إضافة مقاس' : 'Add Size'}
      </Button>
    </Box>
    
    {sizes.length > 0 ? (
      <List>
        {sizes.map((size) => (
          <ListItem
            key={size.id}
            sx={{
              backgroundColor: '#0D0D0D',
              border: '1px solid #2D2D2D',
              borderRadius: '8px',
              mb: 1
            }}
          >
            <ListItemText
              primary={
                <Box>
                  <Typography sx={{ color: '#FFFFFF' }}>
                    {size.name_ar} / {size.name_en}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#FFD700' }}>
                    {language === 'ar' ? 'السعر:' : 'Price:'} +{size.price} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
                  </Typography>
                </Box>
              }
            />
            <ListItemSecondaryAction>
              <IconButton 
                edge="end" 
                onClick={() => handleOpenSizeDialog(size)}
                sx={{ color: '#FFD700', mr: 1 }}
              >
                <EditIcon />
              </IconButton>
              <IconButton 
                edge="end" 
                onClick={() => handleDeleteSize(size.id)}
                sx={{ color: '#FF3D00' }}
              >
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    ) : (
      <Typography sx={{ color: '#B3B3B3', textAlign: 'center', py: 2 }}>
        {language === 'ar' ? 'لا توجد مقاسات مضافة' : 'No sizes added yet'}
      </Typography>
    )}
  </AccordionDetails>
</Accordion>

<Accordion 
  sx={{ 
    mt: 2, 
    backgroundColor: '#1A1A1A',
    border: '1px solid #2D2D2D',
    borderRadius: '8px !important',
    '&:before': { display: 'none' }
  }}
>
  <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#FFD700' }} />}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ExtrasIcon sx={{ color: '#FFD700' }} />
      <Typography sx={{ color: '#FFD700', fontWeight: 600 }}>
        {language === 'ar' ? 'الإضافات' : 'Extra Options'}
      </Typography>
      {extras.length > 0 && (
        <Chip 
          label={extras.length} 
          size="small"
          sx={{ backgroundColor: '#FFD700', color: '#000000', fontWeight: 'bold' }}
        />
      )}
    </Box>
  </AccordionSummary>
  <AccordionDetails>
    <Box sx={{ mb: 2 }}>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={() => handleOpenExtraDialog()}
        sx={{
          borderColor: '#FFD700',
          color: '#FFD700',
          '&:hover': { borderColor: '#FFE55C', backgroundColor: 'rgba(255, 215, 0, 0.08)' }
        }}
      >
        {language === 'ar' ? 'إضافة إضافة' : 'Add Extra'}
      </Button>
    </Box>
    
    {extras.length > 0 ? (
      <List>
        {extras.map((extra) => (
          <ListItem
            key={extra.id}
            sx={{
              backgroundColor: '#0D0D0D',
              border: '1px solid #2D2D2D',
              borderRadius: '8px',
              mb: 1
            }}
          >
            <ListItemText
              primary={
                <Box>
                  <Typography sx={{ color: '#FFFFFF' }}>
                    {extra.name_ar} / {extra.name_en}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#B3B3B3', display: 'block' }}>
                    {extra.description_ar || extra.description}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#FFD700' }}>
                    {language === 'ar' ? 'السعر:' : 'Price:'} +{extra.price} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
                  </Typography>
                </Box>
              }
            />
            <ListItemSecondaryAction>
              <IconButton 
                edge="end" 
                onClick={() => handleOpenExtraDialog(extra)}
                sx={{ color: '#FFD700', mr: 1 }}
              >
                <EditIcon />
              </IconButton>
              <IconButton 
                edge="end" 
                onClick={() => handleDeleteExtra(extra.id)}
                sx={{ color: '#FF3D00' }}
              >
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    ) : (
      <Typography sx={{ color: '#B3B3B3', textAlign: 'center', py: 2 }}>
        {language === 'ar' ? 'لا توجد إضافات مضافة' : 'No extras added yet'}
      </Typography>
    )}
  </AccordionDetails>
</Accordion>

{/* Promotional Offers Section */}
<Accordion 
  sx={{ 
    mt: 2, 
    backgroundColor: '#1A1A1A',
    border: '1px solid #2D2D2D',
    borderRadius: '8px !important'
  }}
>
  <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#FFD700' }} />}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <CardGiftcardIcon sx={{ color: '#FFD700' }} />
      <Typography sx={{ color: '#FFD700', fontWeight: 600 }}>
        {language === 'ar' ? 'العروض الترويجية' : 'Promotional Offers'}
      </Typography>
    </Box>
  </AccordionSummary>
  <AccordionDetails>
    <FormControlLabel
      control={
        <Switch
          checked={formData.has_promotion}
          onChange={(e) => setFormData({ ...formData, has_promotion: e.target.checked })}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#FFD700',
            },
          }}
        />
      }
      label={language === 'ar' ? 'تفعيل العرض الترويجي' : 'Enable Promotion'}
      sx={{ color: '#FFFFFF', mb: 2, display: 'block' }}
    />

    {formData.has_promotion && (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={language === 'ar' ? 'الوصف (عربي)' : 'Description (AR)'}
            value={formData.promotion_description}
            onChange={(e) => setFormData({ ...formData, promotion_description: e.target.value })}
            placeholder="مثال: أضف 10 ر.م واحصل على بيبسي مجاناً"
            InputProps={{ sx: { color: '#FFFFFF' } }}
            InputLabelProps={{ sx: { color: '#B3B3B3' } }}
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={language === 'ar' ? 'الوصف (إنجليزي)' : 'Description (EN)'}
            value={formData.promotion_description_en}
            onChange={(e) => setFormData({ ...formData, promotion_description_en: e.target.value })}
            placeholder="e.g., Add 10 R.m and get free Pepsi"
            InputProps={{ sx: { color: '#FFFFFF' } }}
            InputLabelProps={{ sx: { color: '#B3B3B3' } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="number"
            label={language === 'ar' ? 'الحد الأدنى للإضافة' : 'Minimum Extra Amount'}
            value={formData.promotion_threshold}
            onChange={(e) => setFormData({ ...formData, promotion_threshold: parseFloat(e.target.value) })}
            helperText={language === 'ar' ? 'المبلغ الإضافي المطلوب للحصول على العرض' : 'Extra amount needed to qualify'}
            InputProps={{ sx: { color: '#FFFFFF' } }}
            InputLabelProps={{ sx: { color: '#B3B3B3' } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel sx={{ color: '#B3B3B3' }}>
              {language === 'ar' ? 'نوع المكافأة' : 'Reward Type'}
            </InputLabel>
            <Select
              value={formData.promotion_reward_type}
              onChange={(e) => setFormData({ ...formData, promotion_reward_type: e.target.value })}
              sx={{ color: '#FFFFFF' }}
            >
              <MenuItem value="product">{language === 'ar' ? 'منتج مجاني' : 'Free Product'}</MenuItem>
              <MenuItem value="extra">{language === 'ar' ? 'إضافة مجانية' : 'Free Extra'}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

{formData.promotion_reward_type === 'product' && (
  <Grid item xs={12}>
    <FormControl fullWidth>
      <InputLabel sx={{ color: '#B3B3B3' }}>
        {language === 'ar' ? 'اختر المنتج المجاني' : 'Select Free Product'}
      </InputLabel>
      <Select
        value={formData.promotion_reward_id || ''}
        onChange={(e) => {
          const selectedProduct = allProducts.find(p => p.id === e.target.value);
          setFormData({ 
            ...formData, 
            promotion_reward_id: e.target.value,
            promotion_reward_name: language === 'ar' ? selectedProduct?.name : selectedProduct?.name_en
          });
        }}
        sx={{ color: '#FFFFFF' }}
        disabled={loadingProducts}
      >
        {loadingProducts ? (
          <MenuItem disabled>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={20} sx={{ color: '#FFD700' }} />
              <Typography>{language === 'ar' ? 'جاري التحميل...' : 'Loading...'}</Typography>
            </Box>
          </MenuItem>
        ) : allProducts.length > 0 ? (
          allProducts.map(product => (
            <MenuItem key={product.id} value={product.id}>
              {language === 'ar' ? product.name : product.name_en} - {product.price} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            {language === 'ar' ? 'لا توجد منتجات' : 'No products available'}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  </Grid>
)}

        {formData.promotion_reward_type === 'extra' && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label={language === 'ar' ? 'اسم الإضافة المجانية' : 'Free Extra Name'}
              value={formData.promotion_reward_name}
              onChange={(e) => setFormData({ ...formData, promotion_reward_name: e.target.value })}
              InputProps={{ sx: { color: '#FFFFFF' } }}
              InputLabelProps={{ sx: { color: '#B3B3B3' } }}
            />
          </Grid>
        )}

        {(formData.promotion_reward_type === 'discount_percent' || formData.promotion_reward_type === 'discount_amount') && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="number"
              label={formData.promotion_reward_type === 'discount_percent' 
                ? (language === 'ar' ? 'نسبة الخصم' : 'Discount %')
                : (language === 'ar' ? 'قيمة الخصم' : 'Discount Amount')}
              value={formData.promotion_reward_value}
              onChange={(e) => setFormData({ ...formData, promotion_reward_value: parseFloat(e.target.value) })}
              InputProps={{ sx: { color: '#FFFFFF' } }}
              InputLabelProps={{ sx: { color: '#B3B3B3' } }}
            />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="datetime-local"
            label={language === 'ar' ? 'تاريخ بدء العرض' : 'Promotion Start Date'}
            value={formData.promotion_start_date}
            onChange={(e) => setFormData({ ...formData, promotion_start_date: e.target.value })}
            InputLabelProps={{ shrink: true, sx: { color: '#B3B3B3' } }}
            InputProps={{ sx: { color: '#FFFFFF' } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="datetime-local"
            label={language === 'ar' ? 'تاريخ انتهاء العرض' : 'Promotion End Date'}
            value={formData.promotion_end_date}
            onChange={(e) => setFormData({ ...formData, promotion_end_date: e.target.value })}
            InputLabelProps={{ shrink: true, sx: { color: '#B3B3B3' } }}
            InputProps={{ sx: { color: '#FFFFFF' } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            type="number"
            label={language === 'ar' ? 'الحد الأقصى للاستخدام' : 'Max Uses'}
            value={formData.promotion_max_uses}
            onChange={(e) => setFormData({ ...formData, promotion_max_uses: parseInt(e.target.value) || null })}
            helperText={language === 'ar' ? 'اترك فارغاً للاستخدام غير المحدود' : 'Leave empty for unlimited'}
            InputProps={{ sx: { color: '#FFFFFF' } }}
            InputLabelProps={{ sx: { color: '#B3B3B3' } }}
          />
        </Grid>
      </Grid>
    )}
  </AccordionDetails>
</Accordion>
{/* Size Dialog */}
<Dialog dir={language === 'ar' ? 'rtl' : 'ltr'} open={sizeDialogOpen} onClose={handleCloseSizeDialog} maxWidth="sm" fullWidth>
  <DialogTitle sx={{ backgroundColor: '#0D0D0D', color: '#FFD700' }}>
    {editingSize 
      ? (language === 'ar' ? 'تعديل المقاس' : 'Edit Size')
      : (language === 'ar' ? 'إضافة مقاس جديد' : 'Add New Size')
    }
  </DialogTitle>
  <DialogContent sx={{ backgroundColor: '#0D0D0D', pt: 2 }}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'المعرف' : 'ID'}
          value={sizeForm.id}
          disabled
          InputProps={{ sx: { color: '#B3B3B3' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الإسم' : 'Name'}
          value={sizeForm.name}
          onChange={(e) => setSizeForm({...sizeForm, name: e.target.value})}
          disabled
          InputProps={{ sx: { color: '#B3B3B3' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الاسم (عربي)' : 'Name (AR)'}
          value={sizeForm.name_ar}
          onChange={(e) => setSizeForm({...sizeForm, name_ar: e.target.value})}
          required
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الاسم (إنجليزي)' : 'Name (EN)'}
          value={sizeForm.name_en}
          onChange={(e) => setSizeForm({...sizeForm, name_en: e.target.value})}
          required
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'السعر الإضافي' : 'Additional Price'}
          type="number"
          value={sizeForm.price}
          onChange={(e) => setSizeForm({...sizeForm, price: parseFloat(e.target.value) || 0})}
          required
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
    </Grid>
  </DialogContent>
  <DialogActions sx={{ backgroundColor: '#0D0D0D' }}>
    <Button onClick={handleCloseSizeDialog} sx={{ color: '#B3B3B3' }}>
      {language === 'ar' ? 'إلغاء' : 'Cancel'}
    </Button>
    <Button 
      onClick={handleSaveSize} 
      variant="contained"
      sx={{
        backgroundColor: '#FFD700',
        color: '#000000',
        '&:hover': { backgroundColor: '#FFE55C' }
      }}
    >
      {language === 'ar' ? 'حفظ' : 'Save'}
    </Button>
  </DialogActions>
</Dialog>

{/* Extra Dialog */}
<Dialog dir={language === 'ar' ? 'rtl' : 'ltr'} open={extraDialogOpen} onClose={handleCloseExtraDialog} maxWidth="sm" fullWidth>
  <DialogTitle sx={{ backgroundColor: '#0D0D0D', color: '#FFD700' }}>
    {editingExtra 
      ? (language === 'ar' ? 'تعديل الإضافة' : 'Edit Extra')
      : (language === 'ar' ? 'إضافة إضافة جديدة' : 'Add New Extra')
    }
  </DialogTitle>
  <DialogContent sx={{ backgroundColor: '#0D0D0D', pt: 2 }}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'المعرف' : 'ID'}
          value={extraForm.id}
          disabled
          InputProps={{ sx: { color: '#B3B3B3' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الإسم' : 'Name'}
          value={extraForm.name}
          onChange={(e) => setExtraForm({...extraForm, name: e.target.value})}
          disabled
          InputProps={{ sx: { color: '#B3B3B3' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الاسم (عربي)' : 'Name (AR)'}
          value={extraForm.name_ar}
          onChange={(e) => setExtraForm({...extraForm, name_ar: e.target.value})}
          required
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الاسم (إنجليزي)' : 'Name (EN)'}
          value={extraForm.name_en}
          onChange={(e) => setExtraForm({...extraForm, name_en: e.target.value})}
          required
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الوصف (عربي)' : 'Description (AR)'}
          multiline
          rows={2}
          value={extraForm.description_ar}
          onChange={(e) => setExtraForm({...extraForm, description_ar: e.target.value})}
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'الوصف (إنجليزي)' : 'Description (EN)'}
          multiline
          rows={2}
          value={extraForm.description_en}
          onChange={(e) => setExtraForm({...extraForm, description_en: e.target.value})}
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={language === 'ar' ? 'السعر الإضافي' : 'Additional Price'}
          type="number"
          value={extraForm.price}
          onChange={(e) => setExtraForm({...extraForm, price: parseFloat(e.target.value) || 0})}
          required
          InputProps={{ sx: { color: '#FFFFFF' } }}
          InputLabelProps={{ sx: { color: '#B3B3B3' } }}
        />
      </Grid>
    </Grid>
  </DialogContent>
  <DialogActions sx={{ backgroundColor: '#0D0D0D' }}>
    <Button onClick={handleCloseExtraDialog} sx={{ color: '#B3B3B3' }}>
      {language === 'ar' ? 'إلغاء' : 'Cancel'}
    </Button>
    <Button 
      onClick={handleSaveExtra} 
      variant="contained"
      sx={{
        backgroundColor: '#FFD700',
        color: '#000000',
        '&:hover': { backgroundColor: '#FFE55C' }
      }}
    >
      {language === 'ar' ? 'حفظ' : 'Save'}
    </Button>
  </DialogActions>
</Dialog>
        
        {/* Discount Preview */}
        {formData.discount_percent > 0 && (
          <Alert severity="info" sx={{ mt: 2 }}>
            <Typography variant="body2">
              {language === 'ar' ? 'عرض الخصم' : 'Discount preview'} :<br />
              {language === 'ar' ? 'السعر الأصلي' : 'Original price'} :{ formData.price ? parseFloat(formData.price).toFixed(2) : '0.00'} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}<br />
              {language === 'ar' ? 'نسبة الخصم' : 'Discount percentage'} : {formData.discount_percent}%<br />
              {language === 'ar' ? 'مخفض' : 'Discounted'} : 
               {formData.price 
                ? (parseFloat(formData.price) * (1 - formData.discount_percent / 100)).toFixed(2)
                : '0.00'
              } {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
            </Typography>
          </Alert>
        )}
<ImageUpload
  value={formData.imageUrl}
  onChange={(value) => setFormData(prev => ({ ...prev, imageUrl: value }))}
  productName={formData.name} // Pass product name for AI suggestions
  language={language}
  setIsUploading={(t) => setProdectImageUpload(t)}
/>
                <Box display="flex" gap={2} mt={3}>
                  <Button disabled={prodectImageUpload} type="submit" variant="contained">
                    {editingId ? editProductBtnTxt : addProductBtnTxt} {language === 'ar' ? ' المنتج' : ' Product'}
                  </Button>
                  {editingId && (
                    <Button variant="outlined" onClick={resetForm}>
                      {language === 'ar' ? 'إلغاء' : ' Cancel'}
                    </Button>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

      <Grid item xs={12} md={7}>
        <Card elevation={3}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">
                {language === 'ar' ? 'قائمة المنتجات ' : 'Product List '} ({totalProducts} {language === 'ar' ? ' إجمالي' : ' Total'})
              </Typography>
              <TextField
                size="small"
                label={language === 'ar' ? 'بحث عن منتج' : 'Product search'}
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 300 }}
                placeholder={language === 'ar' ? 'البحث حسب الاسم أو الوصف...' : 'Search by name or description...'}
              />
            </Box>

            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
      <TableContainer component={Paper}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>{language === 'ar' ? 'إسم المنتج' : 'Product Name'}</TableCell>
        <TableCell>{language === 'ar' ? 'السعر' : 'Price'}</TableCell>
        <TableCell>{language === 'ar' ? 'الخسم' : 'Discount'}</TableCell>
        <TableCell>{language === 'ar' ? 'الكمية' : 'Quantity'}</TableCell>
        <TableCell>{language === 'ar' ? 'القسم' : 'Section'}</TableCell>
        <TableCell>{language === 'ar' ? 'الإجراءات' : 'Actions'}</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
{products.map((product) => {
  const isDiscounted = isDiscountActive(product);
  const discountedPrice = calculateDiscountedPrice(product);
  
  return (
    <TableRow key={product.id}>
  <TableCell>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: product.is_active ? '#4caf50' : '#f44336',
        display: 'inline-block'
      }}
    />
    <span>
      {language === 'ar' ? product.name : product.name_en}
    </span>
    {isDiscounted && (
      <Chip 
        label={language === 'ar' ? 'تخفيض' : 'Discount'}
        size="small" 
        color="error" 
        sx={{ ml: 1, fontSize: '0.7rem' }} 
      />
    )}
  </Box>
</TableCell>
      <TableCell>
        <Box>
          {isDiscounted ? (
            <>
              <Typography 
                variant="body2" 
                sx={{ textDecoration: 'line-through', color: 'text.secondary' }}
              >
                {product.price.toFixed(2)} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en }
              </Typography>
              <Typography variant="body1" color="error" fontWeight="bold">
                {discountedPrice.toFixed(2)} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en }
              </Typography>
              <Typography variant="caption" color="success.main">
                {language === 'ar' ? 'خصم' : 'Discounted'} {product.discount_percent}%
              </Typography>
            </>
          ) : (
            <Typography variant="body1">
              {product.price.toFixed(2)} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en }
            </Typography>
          )}
        </Box>
      </TableCell>
      <TableCell>
        {product.discount_percent > 0 ? (
          <Box>
            <Typography variant="body2">
              {product.discount_percent}%
            </Typography>
            {product.discount_start_date && (
              <Typography variant="caption" display="block">
                {language === 'ar' ? 'يبدء' : 'Start'}: {new Date(product.discount_start_date).toLocaleDateString()}
              </Typography>
            )}
            {product.discount_end_date && (
              <Typography variant="caption" display="block">
                {language === 'ar' ? 'ينتهي' : 'End'}: {new Date(product.discount_end_date).toLocaleDateString()}
              </Typography>
            )}
            <Typography 
              variant="caption" 
              color={isDiscounted ? 'success.main' : 'error.main'}
            >
              {isDiscounted ? activeDiscountTxt : unActiveDiscountTxt}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            {language === 'ar' ? 'لايوجد خصم' : 'No Discount'}
          </Typography>
        )}
            </TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                {product.quantity}
                {product.quantity < 10 ? (
                  <ArrowDownward color="error" fontSize="small" sx={{ ml: 1 }} />
                ) : (
                  <ArrowUpward color="success" fontSize="small" sx={{ ml: 1 }} />
                )}
              </Box>
            </TableCell>
            <TableCell>{language === 'ar' ? product.category?.name : product.category?.name_en}</TableCell>
            <TableCell>
              <IconButton onClick={() => handleEdit(product)}>
                <Edit color="primary" />
              </IconButton>
              <IconButton onClick={() => handleDelete(product.id)}>
                <Delete color="error" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
</TableContainer>
                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      showFirstButton
                      showLastButton
                    />
                  </Box>
                )}

                {/* Page Info */}
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
                  Page {currentPage} of {totalPages} • Showing {products.length} of {totalProducts} products
                  {searchTerm && ` • Filtered by: "${searchTerm}"`}
                </Typography>
              </>
            )}
          </CardContent>
        </Card>
      </Grid>
<Grid item xs={12} md={4}>
  <Card elevation={3}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        {language === 'ar' ? 'إدارة الأقسام' : 'Section Manage'}
      </Typography>
      
      {/* Add/Edit Category Form */}
      <TextField
        fullWidth
        margin="normal"
        label={language === 'ar' ? 'إسم القسم عربي' : 'Section name (ar)'}
        value={categoryForm.name}
        onChange={(e) => setCategoryForm({...categoryForm, name: e.target.value})}
        error={!!categoryError.name}
        helperText={categoryError.name}
      />
      <TextField
        fullWidth
        margin="normal"
        label={language === 'ar' ? 'إسم القسم إنجليزي' : 'Section name (en)'}
        value={categoryForm.name_en}
        onChange={(e) => setCategoryForm({...categoryForm, name_en: e.target.value})}
        error={!!categoryError.name_en}
        helperText={categoryError.name_en}
      />
      <TextField
        fullWidth
        margin="normal"
        label={language === 'ar' ? 'وصف القسم عربي' : 'Section descrip (Ar)'}
        multiline
        rows={2}
        value={categoryForm.description}
        onChange={(e) => setCategoryForm({...categoryForm, description: e.target.value})}
        error={!!categoryError.description}
        helperText={categoryError.description}
      />
      <TextField
        fullWidth
        margin="normal"
        label={language === 'ar' ? 'وصف القسم إنجليزي' : 'Section descrip (En)'}
        multiline
        rows={2}
        value={categoryForm.description_en}
        onChange={(e) => setCategoryForm({...categoryForm, description_en: e.target.value})}
        error={!!categoryError.description_en}
        helperText={categoryError.description_en}
      />
      <TextField
          fullWidth
          margin="normal"
          label={language === 'ar' ? 'اقصى حد' : 'Max card item'}
          type="number"
          name="card_limit"
          value={categoryForm.card_limit}
          onChange={(e) => setCategoryForm({...categoryForm, card_limit: e.target.value})}
          inputProps={{ min: 0, max: 100, step: 1 }}
          helperText={language === 'ar' ? 'أدخل 0 لإزالة الحد' : 'Enter 0 to remove the max item'}
      />
      {/* Image Upload Component */}
<SectionImageUpload
  value={categoryForm.ico}
  onChange={(imageUrl) => setCategoryForm({...categoryForm, ico: imageUrl})}
  error={!!categoryError.ico}
  helperText={categoryError.ico}
  language={language}
  setIsUploading={(isUploading) => {
    // Optional: handle global loading state
    console.log('Uploading:', isUploading);
  }}
  maxSize={512} // 512 KB max for ICO files
/>
      
      <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
        <Button
          variant="contained"
          onClick={editingCategory ? handleUpdateCategory : handleAddCategory}
          disabled={!categoryForm.name.trim() || !categoryForm.name_en?.trim()}
        >
          {editingCategory ? editSectionBtnTxt : addSctionBtnTxt}
        </Button>
        {editingCategory && (
          <Button
            variant="outlined"
            onClick={handleCancelEdit}
          >
            {language === 'ar' ? 'إلغاء' : 'Cancel'}
          </Button>
        )}
      </Box>
      
      {/* Categories List */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle1" gutterBottom>
         {language === 'ar' ? 'الأقسام الحالية' : 'Current sections'} ({categories.length})
        </Typography>
        
        {categories.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
            {language === 'ar' ? 'لايوجد أقسام' : 'No sections added'}
          </Typography>
        ) : (
          <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
            {categories.map(category => (
              <ListItem 
                key={category.id}
                sx={{ 
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  mb: 1,
                  backgroundColor: editingCategory?.id === category.id ? 'action.selected' : 'background.paper'
                }}
                secondaryAction={
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <IconButton
                      size="small"
                      onClick={() => handleEditCategory(category)}
                      color="primary"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteCategory(category.id)}
                      color="error"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                }
              >
                <ListItemAvatar>
                  {category.ico ? (
                    <Avatar src={category.ico} sx={{ width: 40, height: 40 }}>
                      {!category.ico && <CategoryIcon />}
                    </Avatar>
                  ) : (
                    <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}>
                      <CategoryIcon />
                    </Avatar>
                  )}
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" noWrap>
                      {language === 'ar' ? category.name : category.name_en}
                    </Typography>
                  }
                  secondary={
                    category.description ? (
                      <Typography variant="caption" color="text.secondary" noWrap>
                        {language === 'ar' ? category.description : category.description_en}
                      </Typography>
                    ) : null
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
        <Button
  variant="outlined"
  startIcon={<DragIcon />}
  onClick={() => setPositionSecManagerOpen(true)}
  sx={{ mb: 2, borderColor: '#FFD700', color: '#FFD700' }}
>
  {language === 'ar' ? 'ترتيب الأقسام' : 'Reorder Sections'}
</Button>
      </Box>
    </CardContent>
  </Card>
</Grid>
<Grid item xs={12} md={6}>
  <Card elevation={3}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        {language === 'ar' ? 'دفعات العملاء والنقاط' : 'Customer payments and points'}
      </Typography>

      {/* Toggle between Payment and Points Exchange */}
      <FormControl component="fieldset" sx={{ mb: 2 }}>
        <FormLabel component="legend">{language === 'ar' ? 'نوع المعاملة' : 'Transaction type'}</FormLabel>
        <RadioGroup
          row
          value={transactionType}
          onChange={(e) => setTransactionType(e.target.value)}
        >
          <FormControlLabel 
            value="payment" 
            control={<Radio />} 
            label={language === 'ar' ? 'عملية دفع' : 'Payment process'}
          />
          <FormControlLabel 
            value="points" 
            control={<Radio />} 
            label={language === 'ar' ? 'تبديل نقاط' : 'Exchange points'}
          />
        </RadioGroup>
      </FormControl>

      {/* Payment Option */}
      {transactionType === 'payment' && (
        <>
          {/* Points Preview */}
          {paymentForm.amount > 0 && (
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>{language === 'ar' ? 'عرض النقاط' : 'Preview points'}:</strong><br />
                {paymentForm.amount} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}  × {pointsData.pointsBer} {language === 'ar' ? 'نقطة' : 'Point'} / 100 {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}  = {Math.floor((paymentForm.amount * pointsData.pointsBer) / 100)} {language === 'ar' ? 'نقطة' : 'Point'}
                <br />
                {language === 'ar' ? 'القيمة' : 'Value'}: {(Math.floor((paymentForm.amount * pointsData.pointsBer) / 100) * pointsData.pointsValue).toFixed(2)} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en} 
              </Typography>
            </Alert>
          )}
          
          <Box component="form" onSubmit={handlePaymentSubmit}>
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'رقم معرف المحفظة' : 'Wallet ID'}
              name="wallet_id"
              value={paymentForm.wallet_id}
              onChange={handlePaymentChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'المبلغ (ر.م)' : 'Amount (R.m)'}
              type="number"
              name="amount"
              value={paymentForm.amount}
              onChange={handlePaymentChange}
              inputProps={{ min: "0.01", step: "0.01" }}
              required
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>{language === 'ar' ? 'طريقة الدفع' : 'Payment method'}</InputLabel>
              <Select
                name="payment_method"
                value={paymentForm.payment_method}
                onChange={handlePaymentChange}
                label={language === 'ar' ? 'طريقة الدفع' : 'Payment method'}
                required
              >
                <MenuItem value="cash">{language === 'ar' ? 'كاش' : 'Cash'}</MenuItem>
                <MenuItem value="credit_card">{language === 'ar' ? 'بطاقة إئتمانية' : 'Visa'}</MenuItem>
                <MenuItem value="debit_card">{language === 'ar' ? 'بطاقة الخصم' : 'Discount card'}</MenuItem>
                <MenuItem value="mobile_payment">{language === 'ar' ? 'الدفع عبر الهاتف' : 'Mobile payment'}</MenuItem>
              </Select>
            </FormControl>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
            >
              {language === 'ar' ? 'إنشاء العملية' : 'Start prossess'}
            </Button>
          </Box>
        </>
      )}

      {/* Points Exchange Option */}
      {transactionType === 'points' && (
        <>
          {/* User Points Balance Display */}
          {customerPoints && (
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>{language === 'ar' ? 'رصيد نقاط العميل' : 'Customer points balance'}:</strong><br />
                {language === 'ar' ? 'النقاط' : 'Points'} : {customerPoints.points_balance}<br />
                {language === 'ar' ? 'القيمة' : 'Points value'}: {(customerPoints.points_balance * pointsData.pointsValue).toFixed(2)} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}<br />
                {language === 'ar' ? 'رصيد المحفظة' : 'Wallet balance'}: {customerPoints.wallet_balance} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
              </Typography>
            </Alert>
          )}

          <Box component="form" onSubmit={handlePointsExchange}>
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'رقم معرف المحفظة' : 'Wallet ID'}
              name="wallet_id"
              value={pointsForm.wallet_id}
              onChange={handlePointsChange}
              required
            />
            
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'عدد النقاط المستبدلة' : 'Number of points exchanged'}
              type="number"
              name="points_to_exchange"
              value={pointsForm.points_to_exchange}
              onChange={handlePointsChange}
              inputProps={{ 
                min: "1", 
                max: customerPoints?.points_balance || 0,
                step: "1"
              }}
              required
              helperText={`${language === 'ar' ? 'أقصى عدد' : 'Max number'}: ${customerPoints?.points_balance || 0} ${language === 'ar' ? ' نقطة متاحة' : ' Available point'}`}
            />

            {/* Points Value Preview */}
            {pointsForm.points_to_exchange > 0 && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <Typography variant="body2">
                  <strong>{language === 'ar' ? 'قيمة الإستبدال' : 'Exchange vlaue'}:</strong><br />
                  {pointsForm.points_to_exchange} {language === 'ar' ? 'نقطة' : 'Point'} × {pointsData.pointsValue} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en} = 
                  {(pointsForm.points_to_exchange * pointsData.pointsValue).toFixed(2)} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
                </Typography>
              </Alert>
            )}

            <Button
              type="submit"
              variant="contained"
              color="secondary"
              sx={{ mt: 2 }}
              disabled={!customerPoints || pointsForm.points_to_exchange > customerPoints.points_balance}
            >
              {language === 'ar' ? 'إستبدال النقاط' : 'Exchange points'}
            </Button>
          </Box>
        </>
      )}
    </CardContent>
  </Card>
</Grid>
<Grid item xs={12} md={6}>
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {language === 'ar' ? '⚙️ إعدادات النظام' : '⚙️ System settings'}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {message.text && (
            <Alert severity={message.type} sx={{ mb: 2 }} onClose={() => setMessage({ type: '', text: '' })}>
              {message.text}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmitSettings}>
              <FormControlLabel
      control={
        <Switch
          checked={settings.deliver_status === '1'}
          onChange={handleChangeSettings('deliver_status')}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#FFD700',
            },
          }}
        />
      }
      label={language === 'ar' ? 'تفعيل الدلفري' : 'Enable Delivery'}
      sx={{ color: '#FFFFFF', mb: 2, display: 'block' }}
    />
            {/* Points per 100 R.m */}
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'النقاط لكل 100 ر.م' : 'Points per 100 R.m'}
              type="number"
              value={settings.points_per_100_EGP}
              onChange={handleChangeSettings('points_per_100_EGP')}
              inputProps={{ 
                min: "0",
                step: "1"
              }}
              required
              helperText={language === 'ar' ? 'عدد النقاط التي يحصل عليها العميل لكل 100 ر.م إنفاق' : 'Number of points a customer earns for every 100 R.m spent'}
            />

            {/* Points Value */}
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'قيمة النقطة (ر.م)' : 'Point value (R.m)'}
              type="number"
              value={settings.point_value_in_EGP}
              onChange={handleChangeSettings('point_value_in_EGP')}
              inputProps={{ 
                min: "0.01",
                step: "0.01"
              }}
              required
              helperText={language === 'ar' ? 'قيمة كل نقطة' : 'Each point value'}
            />

            {/* Delivery Value */}
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'رسوم التوصيل (ر.م)' : 'Delivery fees (R.m)'}
              type="number"
              value={settings.deliver_value_in_EGP}
              onChange={handleChangeSettings('deliver_value_in_EGP')}
              inputProps={{ 
                min: "0",
                step: "0.01"
              }}
              required
              helperText={language === 'ar' ? 'رسوم التوصيل الأساسية' : 'Basic delivery fees'}
            />

            {/* service charge Value */}
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'نسبة رسوم الخدمة %' : 'Service charge percentage %'}
              type="number"
              value={settings.service_charge_percent}
              onChange={handleChangeSettings('service_charge_percent')}
              inputProps={{ 
                min: "0",
                step: "0.01"
              }}
              required
              helperText={language === 'ar' ? 'نسبة رسوم الخدمة الأساسية' : 'Basic service fee percentage'}
            />

            {/* threshold min amount */}
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'إجمالي الخصم المكتسب' : 'Threshold min amount'}
              type="number"
              value={settings.threshold_min_amount}
              onChange={handleChangeSettings('threshold_min_amount')}
              inputProps={{ 
                min: "0",
                step: "0.01"
              }}
              required
              helperText={language === 'ar' ? 'إجمالي قيمة الخصم المكتسب' : 'Total Threshold amount'}
            />

            {/* threshold discount Value */}
            <TextField
              fullWidth
              margin="normal"
              label={language === 'ar' ? 'قيمة الخصم المكتسب' : 'Threshold value'}
              type="number"
              value={settings.threshold_discount_value}
              onChange={handleChangeSettings('threshold_discount_value')}
              inputProps={{ 
                min: "0",
                step: "0.01"
              }}
              required
              helperText={language === 'ar' ? 'قيمة الخصم المكتسب' : 'Threshold value'}
            />

            {/* Preview Section */}
            <Paper elevation={1} sx={{ p: 2, mt: 2}}>
              <Typography variant="subtitle2" gutterBottom>
                {language === 'ar' ? 'معاينة الإعدادات' : 'Settings preview'}:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • {language === 'ar' ? 'العميل ينفق 100 ر.م ← يحصل على' : 'The customer spends 100 R.m → receives'} {settings.points_per_100_EGP || 0} {language === 'ar' ? 'نقطة' : 'Point'}
                <br />
                • {language === 'ar' ? 'كل نقطة ← تساوي ' : 'Each point → equals'} {settings.point_value_in_EGP || 0} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
                <br />
                • {language === 'ar' ? 'رسوم التوصيل ← ' : 'Delivery fees → '} {settings.deliver_value_in_EGP || 0} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
              </Typography>
              {settings.points_per_100_EGP && settings.point_value_in_EGP && (
                <Typography variant="body2" sx={{ mt: 1, color: '#FFD700' }}>
                  {language === 'ar' ? 'العميل ينفق 500 ر.م ← يحصل على' : 'The customer spends 500 R.m → receives'} {Math.floor((500 * settings.points_per_100_EGP) / 100)} {language === 'ar' ? 'نقطة' : 'Point'} 
                  {language === 'ar' ? ' ← تساوي ' : ' → equal '} {((500 * settings.points_per_100_EGP / 100) * settings.point_value_in_EGP).toFixed(2)} {language === 'ar' ? keywordsData.carance_txt_ar : keywordsData.carance_txt_en}
                </Typography>
              )}
            </Paper>

            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              sx={{ mt: 3 }}
              disabled={loading}
              fullWidth
            >
              {loading ? savingBtnTxt : saveBtnTxt}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Grid>
      </Grid>
      <ProductPositionManager
  open={positionManagerOpen}
  onClose={() => setPositionManagerOpen(false)}
  language={language}
  onSuccess={() => {
    // Refresh your products list
    fetchProducts();
  }}
/>
<CategoryPositionManager
  open={positionSecManagerOpen}
  onClose={() => setPositionSecManagerOpen(false)}
  language={language}
  onSuccess={() => {
    // Refresh your categories list after reordering
    fetchCategories();
  }}
/>
      {/* Out of Stock Dialog */}
      <OutOfStockDialog
        open={outOfStockDialogOpen}
        onClose={() => setOutOfStockDialogOpen(false)}
        onRestockComplete={() => {
          // Refresh dashboard data after restock
          fetchProducts();
        }}
      />
    </Container>
  );
};

export default AdminDashboard;